module.exports = function(obj) {
  var n = 0;
  for(var k in obj) {
    if(obj.hasOwnProperty(k)) {
      n += 1;
    }
  }

  return n;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/storage2/lib/num-keys.js
 ** module id = 10
 ** module chunks = 0
 **/